import dayjs from 'dayjs';
import * as userApi from '../../services/api/userApi';
import * as _ from 'lodash';

export function getDueDateTextStyle(dueDate) {
  let dueDateTextStyle;
  let daysLeft = dayjs(dueDate).diff(dayjs(), 'days');
  if (daysLeft > 1) {
    dueDateTextStyle = { color: '#0caae3' };
  }
  if (daysLeft <= 1 && daysLeft >= 0) {
    dueDateTextStyle = { color: '#f05060' };
  }

  return dueDateTextStyle;
}

export function getUserAvatar(userId) {
  return userApi.getUser(userId).then(res => {
    return res.data.picture;
  });
}

export function getLastComment(comments) {
  if (!_.isEmpty(comments)) {
    return comments[comments.length - 1];
  }
  return null;
}
